// extracted by mini-css-extract-plugin
module.exports = {"conteiner":"Card_conteiner__2DWII","card":"Card_card__1-uw2","h":"Card_h__1L3Vn"};